import { StrictMode } from 'react';
import { z } from 'zod';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import './ui/globals.css';
import { App } from './app/App';
import { followDocumentLang, initI18n } from './app/i18n';
import { applyMotion } from './ui/motion';

// No `Function('')` probe from zod under the production CSP (P12), whatever screen parses first.
z.config({ jitless: true });

applyMotion();
const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

initI18n().then((i18n) => {
  followDocumentLang(i18n);
  createRoot(root).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </StrictMode>,
  );
});
